import { render, staticRenderFns } from "./ShareToEdit.vue?vue&type=template&id=0285b1ba&scoped=true"
import script from "./ShareToEdit.vue?vue&type=script&lang=js"
export * from "./ShareToEdit.vue?vue&type=script&lang=js"
import style0 from "./ShareToEdit.vue?vue&type=style&index=0&id=0285b1ba&prod&lang=scss&scoped=true"
import style1 from "./ShareToEdit.vue?vue&type=style&index=1&id=0285b1ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0285b1ba",
  null
  
)

export default component.exports